angular.module('autoremind.satellites')
    .directive('lastError', ['$location', 'logger', 'satelliteService', 'userSettings',
    function ($location, logger, satelliteService, userSettings) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/satellites/last-error.html',
            scope: {
                parentViewModel: '=',
                activated: '='
            },
            link: function ($scope, element, attrs) {
                $scope.userSettings = userSettings;
                $scope.satelliteService = satelliteService;
                $scope.viewModel = $scope.parentViewModel.tabViews.lasterrors;
                $scope.viewModel.loadingIndicator = { 'state': false, 'refCount': 0 };
                $scope.viewModel.fetchState = {
                    buttonLabel: "Refresh",
                    busy: false
                };
                if ($scope.viewModel.lastErrorSort === undefined) {
                    $scope.viewModel.lastErrorSort = { column: "created", descending: true };
                }
                $scope.multiselectSettingsErrorStatuses = {
                    displayProp: 'text',
                    idProp: 'id',
                    externalIdProp: 'type',
                    showCheckAll: false,
                    showUncheckAll: false,
                    showGroupDivider: true,
                    groupBy: 'type'
                };
                $scope.multiselectcustomTextsStatuses = {
                    checkAll: '',
                    uncheckAll: 'Deselect all',
                    buttonDefaultText: 'User status',
                    dynamicButtonTextSuffix: 'selected'
                };
                $scope.getLastErrors = function () {
                    satelliteService.getLastErrors($scope.viewModel.loadingIndicator)
                        .then(function (data) {
                        $scope.viewModel.lastErrors = data.errors;
                        $scope.viewModel.lastErrorsNow = data.now; // TODO: Consider having a common now used for satellites, checkins, etc.
                        logger.debug('Got ' + $scope.viewModel.lastErrors.length + ' errors');
                    });
                };
                $scope.viewModel.lastErrorTimeLimitSelected = "1";
                $scope.viewModel.lastErrorSchedulerStateSelected = "active";
                $scope.lastErrorDataFilter = function (error) {
                    if ($scope.viewModel.lastErrorTimeLimitSelected === 'all') {
                        return true;
                    }
                    if ($scope.viewModel.lastErrorTimeLimitSelected !== undefined) {
                        var now = Math.floor(new Date().getTime() / 1000);
                        switch ($scope.viewModel.lastErrorTimeLimitSelected) {
                            case '1':
                                if (now - 60 * 60 <= error.created / 1000) {
                                    return true;
                                }
                                break;
                            case '4':
                                if (now - 4 * 60 * 60 <= error.created / 1000) {
                                    return true;
                                }
                                break;
                            case '12':
                                if (now - 12 * 60 * 60 <= error.created / 1000) {
                                    return true;
                                }
                                break;
                            case '24':
                                if (now - 24 * 60 * 60 <= error.created / 1000) {
                                    return true;
                                }
                                break;
                            case '>24':
                                if (now - 24 * 60 * 60 > error.created / 1000) {
                                    return true;
                                }
                                break;
                        }
                        return false;
                        // if ($scope.viewModel.lastErrorTimeLimitSelected === '24' &&
                        //         $scope.viewModel.lastErrorsNow - $scope.viewModel.lastErrorTimeLimitSelected*60*60*1000 > error.created ) return false;
                    }
                    return true;
                };
                $scope.accountFilter = function (satellite) {
                    var searchAccount = $scope.viewModel.searchAccount;
                    return !searchAccount ||
                        (satellite.autoremindAccount &&
                            satellite.autoremindAccount !== '' &&
                            satellite.autoremindAccount.toLowerCase().indexOf(searchAccount.toLowerCase()) !== -1);
                };
                $scope.userSchedulerStatusFilter = function (satellite) {
                    return satelliteService.satellitesUserSchedulerStatesFilter(satellite, $scope.userSettings.model.userSchedulerStatusesSelected);
                };
                $scope.changeLastErrorSorting = function (column) {
                    if ($scope.viewModel.lastErrorSort.column === column) {
                        $scope.viewModel.lastErrorSort.descending = !$scope.viewModel.lastErrorSort.descending;
                    }
                    else {
                        $scope.viewModel.lastErrorSort.column = column;
                        $scope.viewModel.lastErrorSort.descending = false;
                    }
                };
                $scope.toggleSelectedRow = function (next) {
                    if ($scope.viewModel.selectedLogEvent === next) {
                        $scope.viewModel.selectedLogEvent = null;
                        return;
                    }
                    $scope.viewModel.selectedLogEvent = next;
                };
                $scope.init = function () {
                    $scope.getLastErrors();
                };
                $scope.hasBeenActivatedOnce = false;
                $scope.$watch('activated', function (newActivated, oldActivated) {
                    if (newActivated && !$scope.hasBeenActivatedOnce) {
                        $scope.hasBeenActivatedOnce = true;
                        $scope.init();
                    }
                });
            } // end of link()
        };
    }]);
//# sourceMappingURL=last-error.directive.js.map